export const actionTypes = {
  REQUEST_START: 'AUTHORIZATION.RUN_AS.REQUEST_START',
  SUCCESS: 'AUTHORIZATION.RUN_AS.SUCCESS',
  FAILURE: 'AUTHORIZATION.RUN_AS.FAILURE',
  RESET: 'AUTHORIZATION.RUN_AS.RESET',
};

export function startRequest(inn) {
  return {
    type: actionTypes.REQUEST_START,
    payload: inn,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.FAILURE,
    payload: error,
  };
}

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}
